import { render, staticRenderFns } from "./ParametrizacaoFiliaisCompra.vue?vue&type=template&id=34e3c424&scoped=true"
import script from "./ParametrizacaoFiliaisCompra.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoFiliaisCompra.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoFiliaisCompra.vue?vue&type=style&index=0&id=34e3c424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e3c424",
  null
  
)

export default component.exports